/*
 *
 * Login constants
 *
 */

export const LOGIN_WATCHER = "app/Login/LOGIN_WATCHER"
export const LOGIN_FAILED = "app/Login/LOGIN_FAILED"
export const LOGIN_SUCCESS = "app/Login/LOGIN_SUCCESS"
export const LOGIN_EXCEED = "app/Login/LOGIN_EXCEED"
export const LOGIN_RESET = "app/Login/LOGIN_RESET"
export const LOGIN_PROOF_INTEGRATED = "app/Login/LOGIN_PROOF_INTEGRATED"

export const LOGIN_COMPANY_WATCHER = "app/Login/LOGIN_COMPANY_WATCHER"

export const TWO_FACTOR_AUTH_RESEND_WATCHER =
  "app/TwoFactorAuth/TWO_FACTOR_AUTH_RESEND"
